import { getSession } from 'utils/auth'
import { useSatuEventTracker } from 'utils/satuEvent'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { convertToKeyValuePairs } from 'utils/object'

const SATU_EVENT_NAME = 'survey_kemudahan_pengkin_interaction_v1'

type TrackerParams = {
  actor: Actor
  eventCategory: EventCategory
  eventAction: EventAction
  eventLabel?: string
  customDimensions?: Record<string, string>
}

export type Actor =
  | 'pamong'
  | 'kepala_skb'
  | 'penilik'
  | 'guru'
  | 'ks'
  | 'gpk'
  | 'ps'
type EventAction = 'view' | 'view_gform' | 'submit'
type EventCategory =
  | 'survey_kemudahan_perencanaan'
  | 'survey_kemudahan_pelaksanaan'
  | 'survey_kemudahan_kinerja_harian'

export function useKemudahanSurveyTrackEvent() {
  const { SETrackEvent } = useSatuEventTracker()
  const session = getSession()

  const { period } = usePeriodContext()

  const trackEvent = (params: TrackerParams) => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        attributes: {
          event_category: params.eventCategory,
          event_action: params.eventAction,
          event_label: params.eventLabel,
          ptk_id: session?.user?.ptkId,
          email: session?.user?.email,
          period_id: period?.id,
          pengkin_type: params.actor,
          user_agent: navigator?.userAgent || '',
        },
        custom_dimensions: params.customDimensions
          ? convertToKeyValuePairs(params.customDimensions)
          : undefined,
      },
      sendUserData: true,
      sendDefaultParams: true,
      sendAttributes: false,
    })
  }

  return {
    trackEvent,
  }
}
